/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Finish_Confirm_Warn_Vekn_IdsInputs */



/**
* | output |
* | --- |
* | "{count} player(s) have no VEKN ID. Results can't be sent to VEKN until every ranked player has one." |
*
* @param {Finish_Confirm_Warn_Vekn_IdsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const finish_confirm_warn_vekn_ids = /** @type {((inputs: Finish_Confirm_Warn_Vekn_IdsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finish_Confirm_Warn_Vekn_IdsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} joueur(s) sans ID VEKN. Les résultats ne pourront pas être envoyés à la VEKN tant que chaque joueur classé n'en a pas un.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} jugador(es) sin ID VEKN. Los resultados no se pueden enviar a la VEKN hasta que cada jugador clasificado tenga uno.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} jogador(es) sem ID VEKN. Os resultados não podem ser enviados à VEKN até que cada jogador classificado tenha um.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} giocatore/i senza ID VEKN. I risultati non si possono inviare alla VEKN finché ogni giocatore in classifica non ne ha uno.`)
	return /** @type {LocalizedString} */ (`${i?.count} player(s) have no VEKN ID. Results can't be sent to VEKN until every ranked player has one.`)
});